// extracted by mini-css-extract-plugin
export var container = "_fx-0";
export var content = "_fx-3";
export var customerTitle = "_fx-4";
export var empty = "_fx-5";
export var gray = "_fx-6";
export var header = "_fx-7";
export var info = "_fx-8";
export var loading = "_fx-2";
export var loadingCard = "_fx-9";
export var oneLine = "_fx-a";
export var personName = "_fx-e";
export var pillContainer = "_fx-b";
export var selected = "_fx-1";
export var text = "_fx-c";
export var twoLines = "_fx-d";
export var unread = "_fx-f";
export var unreadIndicator = "_fx-g";